<template>
  <div id="filter-mobile-modal">
    <form action="#" id="post-filter-modal-mobile">
      <h6 class="fs-13" style="border-bottom: 1px solid #ccc">Filter Source</h6>
      <div class="row">
        <div v-for="(source, index) in sources_list" :key="index" class="form-check complete col-6">
          <input type="checkbox" :id="'check-' + index" v-model="filter_sources" :value="source.id" />
          <label :for="'check-' + index"> {{ source.name }}</label>
        </div>
      </div>

      <h6 class="fs-13" style="border-bottom: 1px solid #ccc">
        Filter Hoaks Justifikasi
      </h6>
      <div class="row">
        <div class="form-check complete col-4">
          <input type="checkbox" id="check-positif" v-model="filter_sentimen" value="1" />
          <label for="check-positif"> Fakta</label>
        </div>
        <div class="form-check complete col-4">
          <input type="checkbox" id="check-netral" v-model="filter_sentimen" value="0" />
          <label for="check-netral"> Tidak Diketahui</label>
        </div>
        <div class="form-check complete col-4">
          <input type="checkbox" id="check-negatif" v-model="filter_sentimen" value="-1" />
          <label for="check-negatif"> Hoaks</label>
        </div>
      </div>

      <div class="row m-t-20" align="right">
        <div class="col-md-12">
          <button class="btn btn-danger" data-dismiss="modal">Batal</button>
          <button @click="saveFilter" class="btn btn-primary m-l-5" data-dismiss="modal">
            Simpan
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "modal_filter_mobile",
  data() {
    return {
      sources_list: [],
      filter_sources: [],
      filter_sentimen: [],
    };
  },
  methods: {
    saveFilter: function () {
      let q_filter_sources = this.filter_sources.join(",");
      let q_filter_sentimen = this.filter_sentimen.join(",");
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      let change = 0;

      if ("page" in queries) {
        delete queries.page;
      }

      if (q_filter_sources) {
        queries.sources = btoa(q_filter_sources);
        change++;
      } else {
        if ("sources" in queries) {
          delete queries.sources;
          change++;
        }
      }
      if (q_filter_sentimen) {
        queries.hoax = btoa(q_filter_sentimen);
        change++;
      } else {
        if ("hoax" in queries) {
          delete queries.hoax;
          change++;
        }
      }

      if (change > 0) {
        queries.page = 1;
        this.$router.replace({ query: queries });
      }
    },
  },
  created: function () {
    this.sources_list = [
      {
        id: "twitter",
        name: "Twitter",
      },
      {
        id: "facebook",
        name: "Facebook",
      },
      {
        id: "instagram",
        name: "Instagram",
      },
      {
        id: "tiktok",
        name: "Tiktok",
      },
      {
        id: "youtube",
        name: "Youtube",
      },
      {
        id: "linkedin",
        name: "Linkedin",
      },
      {
        id: "news",
        name: "Media Online",
      },
      {
        id: "forum",
        name: "Forum",
      },
      {
        id: "blog",
        name: "Blog",
      },
    ];
    if (this.$store.getters.user.project.project_detail.tipe == 1) {
      this.sources_list.push({
        id: "media_tv",
        name: "Media TV",
      });
      this.sources_list.push({
        id: "media_cetak",
        name: "Media Cetak",
      });
    }
    let query = this.$route.query;
    if ("sources" in query) {
      this.filter_sources = atob(query.sources).split(",");
    }
    if ("hoax" in query) {
      this.filter_sentimen = atob(query.hoax).split(",");
    }
  },
};
</script>